import React, { useState } from "react";
import emailjs from 'emailjs-com';

const EmailForm = () => {
  const [status, setStatus] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("");

    emailjs
      .sendForm(
        "service_imaratek",      // ✅ YOUR SERVICE ID
        "template_imaratek",     // ✅ YOUR TEMPLATE ID
        e.target,
        "EqcZYu-YAH_yLqp33"       // ✅ YOUR PUBLIC KEY
      )
      .then(
        () => {
          setStatus("Message sent successfully!");
          e.target.reset();
        },
        (error) => {
          console.error("EmailJS Error:", error);
          setStatus("Failed to send the message, please try again.");
        }
      );
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100 font-Nunito">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded shadow-md w-full max-w-md"
      >
        <h2 className="text-2xl font-bold mb-4 text-center">Get A Quote</h2>

        <input type="hidden" name="from_name" value="Imaratek Website" />

        <div className="mb-4">
          <label className="block text-sm font-bold mb-2">Name</label>
          <input
            type="text"
            name="name"
            required
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-bold mb-2">Email</label>
          <input
            type="email"
            name="reply_to"
            required
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-bold mb-2">Product</label>
          <select
            name="product"
            required
            className="w-full border px-3 py-2 rounded"
          >
            <option value="">Select a product</option>
            <option value="Box Profile">Box Profile</option>
            <option value="Corrugated">Corrugated</option>
            <option value="Brick Tiles">Brick Tiles</option>
            <option value="Orientile">Orientile</option>
            <option value="Elegantile">Elegantile</option>
            <option value="Accessories">Accessories</option>
            <option value="Decra Tiles">Decra Tiles</option>
          </select>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-bold mb-2">Message</label>
          <textarea
            name="message"
            required
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <button
          type="submit"
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded w-full"
        >
          Send
        </button>

        {status && (
          <p
            className={`mt-4 text-center text-sm ${
              status.includes("success")
                ? "text-green-600"
                : "text-red-600"
            }`}
          >
            {status}
          </p>
        )}
      </form>
    </div>
  );
};

export default EmailForm;
